import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  MetaverseServiceHigh,
  MetaverseServiceUniversal,
  MetaverseServiceStack,
  MetaverseServiceSecure,
  MetaverseServiceCrypto,
  MetaverseServiceMonitoring,
} from "../../../app-constants";

function Metaverseservices() {
  return (
    <section className="metaverse_services p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Achieve Excellence with TekRevol’s Metaverse Development Services
            </h2>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-5">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="metaverse_service_box">
                  <div className="metaverse_service_icon">
                    {MetaverseServiceHigh}
                  </div>
                  <div className="metaverse_service_content">
                    <h5>High-Performance Decentralized Infrastructure</h5>
                    <p>
                      We deploy your metaverse on a high-bandwidth,
                      decentralized infrastructure, ensuring minimal latency and
                      robust real-time interactions.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="metaverse_service_box">
                  <div className="metaverse_service_icon">
                    {MetaverseServiceUniversal}
                  </div>
                  <div className="metaverse_service_content">
                    <h5>Universal Interoperability Standards</h5>
                    <p>
                      Using open and interoperable standards, we facilitate
                      seamless integration of 3D assets, multimedia, and
                      interactive elements across diverse platforms and devices.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="metaverse_service_box">
                  <div className="metaverse_service_icon">
                    {MetaverseServiceStack}
                  </div>
                  <div className="metaverse_service_content">
                    <h5>Comprehensive Full-Stack Development</h5>
                    <p>
                      Our full-stack development services leverage advanced
                      technologies like Web XR, Web Assembly, Web GPU, and
                      Shader Language to create immersive and responsive user
                      experiences.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="metaverse_service_box">
                  <div className="metaverse_service_icon">
                    {MetaverseServiceSecure}
                  </div>
                  <div className="metaverse_service_content">
                    <h5>Secure & Efficient Smart Contracts</h5>
                    <p>
                      We design and implement smart contracts that enable
                      transparent, secure, and efficient transactions, enhancing
                      trust and functionality within your metaverse.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="metaverse_service_box">
                  <div className="metaverse_service_icon">
                    {MetaverseServiceCrypto}
                  </div>
                  <div className="metaverse_service_content">
                    <h5>Advanced Crypto Payment Solutions</h5>
                    <p>
                      Integrating cutting-edge crypto wallets and gateways, we
                      provide secure, versatile payment solutions, incorporating
                      features like atomic swaps and liquidity pools for
                      seamless transactions.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="metaverse_service_box">
                  <div className="metaverse_service_icon">
                    {MetaverseServiceMonitoring}
                  </div>
                  <div className="metaverse_service_content">
                    <h5>Continuous Monitoring & Upgrades</h5>
                    <p>
                      We ensure your metaverse operates at peak performance with
                      proactive maintenance, regular upgrades, and real-time
                      monitoring of networks, nodes, and smart contracts.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Metaverseservices;
